<div class="container" [ngStyle]="{left: (-current_frame*100) + '%'}">
	<div class="frame" *ngFor="let frame of frames" alt="" [ngStyle]="{backgroundImage: 'url(/'+frame.src+')'}"></div>
</div>
<p class="prev" (click)="change(current_frame - 1)"></p>
<p class="next" (click)="change(current_frame + 1)"></p>
<div class="button" *ngIf="actionText">
	<p>
		<button (click)="action.emit()">{{actionText}}</button>
	</p>
</div>
<p class="indicators">
	<span *ngFor="let frame of frames; let i = index" (click)="change(i)">{{ i == current_frame ? '●' : '○'}}</span>
</p>
